import { useRef, memo } from 'react';
import { useToggleState } from 'react-stately';
import { useCheckbox } from 'react-aria';
import { ToggleProps } from "@react-types/checkbox";



export interface CheckboxProps extends ToggleProps {
}


const Checkbox = (props: CheckboxProps) => {
	const { children } = props;
	
	let ref = useRef<HTMLInputElement>(null);
	let state = useToggleState(props);
	let { inputProps } = useCheckbox(props, state, ref);

	return (
		<div className='component-checkbox disable-selection'>

			<label>
				<input {...inputProps} ref={ref} />
				{children}
			</label>
		
		</div>
	)
}


export default memo(Checkbox);